import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { inject } from 'mobx-react';
import PrivateRoute from '../router/privateRoute';
import Callback from '../account/callback';
import OidcError from '../account/oidcError';
import LoggenInUserTabs from '../myProfile';
import TeamsContainer from '../teams';
import SettingsContainer from '../settings';
import SilentRenewCallback from '../account/silentRenewCallback';
import LoginContainer from '../account/loginContainer';
import UsersContainer from '../users';
import RolesContainer from '../roles';
import EditRoleContainer from '../roles/editRole';
import ForgotPassword from '../account/forgotPasswordFlow/forgotPassword';
import ResetPassword from '../account/forgotPasswordFlow/resetPassword';
import ChangePasswordContainer from '../account/forgotPasswordFlow/changePasswordContainer';
import SetupAuthAppContainer from '../account/twoFA/setupAuthAppContainer';
import ExternalLoginError from '../account/externalLoginError';
import SetTenantAdminPassword from '../account/forgotPasswordFlow/setTenantAdminPassword';

@inject('oidcStore', 'translationsStore')
export default class InnerRouter extends Component {

    render() {
        
        return(
            <div>
                <Route path='/login' exact component={LoginContainer} />
                <Route path='/callback' exact component={Callback} />
                <Route path='/silentrenewcallback' exact component={SilentRenewCallback} />
                <Route path='/oidcerror' exact component={OidcError} />
                <Route path='/forgotpassword' exact component={ForgotPassword} />
                <Route path='/resetpassword' exact component={ResetPassword} />
                <Route path='/changepassword' exact component={ChangePasswordContainer} />
                <Route path='/setupauth' exact component={SetupAuthAppContainer} />
                <Route path='/externalloginerror' exact component={ExternalLoginError} />
                <Route path='/setTenantAdminPassword' exact component={SetTenantAdminPassword} />
                <PrivateRoute path='/teams' exact component={TeamsContainer} routeId={1} />
                <PrivateRoute path='/' exact component={UsersContainer} routeId={2} />
                <PrivateRoute path='/users' exact component={UsersContainer} routeId={2} />
                <PrivateRoute path='/roles' exact component={RolesContainer} routeId={4} />
                <PrivateRoute path='/roles/:id' exact component={EditRoleContainer} routeId={4} />
                
                <PrivateRoute path='/settings/general' exact component={SettingsContainer} routeId={3} />
                <PrivateRoute path='/settings/ldap' exact component={SettingsContainer} routeId={3} />
                <PrivateRoute path='/settings/saml' exact component={SettingsContainer} routeId={3} />
                <PrivateRoute path='/settings/masterAccessControl' exact component={SettingsContainer} routeId={3} />
                <PrivateRoute path='/settings/security' exact component={SettingsContainer} routeId={3} />
                <PrivateRoute path="/profile" exact component={LoggenInUserTabs} routeId={5} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/router/innerRouter.jsx